import { Injectable } from '@angular/core';
import { ThemeType } from '../models/theme.models';

/**
 * Note: This project currently supports only the Light theme.
 * Update this function to toggle between Light and Dark themes when Dark mode support is implemented.
 */
@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentTheme: ThemeType = ThemeType.Light;

  getTheme(): ThemeType {
    return this.currentTheme;
  }

  setTheme(theme: ThemeType): void {
    if (this.currentTheme !== theme) {
      this.currentTheme = theme;
      document.body.classList.remove(ThemeType.Light, ThemeType.Dark);
      document.body.classList.add(theme);
    }
  }

  toggleTheme(): void {
    this.setTheme(this.currentTheme === ThemeType.Light ? ThemeType.Dark : ThemeType.Light);
  }
}
